import { render, staticRenderFns } from "./MarkupHeatmap.vue?vue&type=template&id=80e78a84&"
import script from "./MarkupHeatmap.vue?vue&type=script&lang=js&"
export * from "./MarkupHeatmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports